(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["off-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('off-campaign-carousel')) {
  customElements.define('off-campaign-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.choices = [...this.querySelectorAll('[data-go]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.updatePause();
      this.addEventListener('click', e => {
        const control = e.target.closest('button');
        if (!control) return;
        if (control.hasAttribute('data-pause')) {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        } else if (control.hasAttribute('data-next')) this.go(this.index + 1, true);
        else if (control.hasAttribute('data-previous')) this.go(this.index - 1, true);
        else if (control.hasAttribute('data-go')) this.go(Number(control.dataset.go), true);
      }, {signal});
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
          this.choices[this.index]?.focus();
        }
      }, {signal});
      this.addEventListener('pointerenter', () => {this.hovered = true; this.schedule();}, {signal});
      this.addEventListener('pointerleave', () => {this.hovered = false; this.schedule();}, {signal});
      this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, {signal});
      this.addEventListener('focusout', e => {if (!this.contains(e.relatedTarget)) {this.focused = false; this.schedule();}}, {signal});
      this.addEventListener('pointerdown', e => {if(e.pointerType === 'touch') this.touch = {x:e.clientX,y:e.clientY};}, {signal});
      this.addEventListener('pointerup', e => {
        if (!this.touch) return;
        const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y;
        this.touch=null;
        if (Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)) this.go(this.index+(dx<0?1:-1),true);
      }, {signal});
      this.addEventListener('pointercancel', () => {this.touch=null;}, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => {if(this.motion.matches) this.paused=true;this.updatePause();this.schedule();}, {signal});
      document.addEventListener('shopify:block:select', e => {
        const index=this.slides.findIndex(slide=>slide===e.target||slide.contains(e.target));
        if(index>=0){this.paused=true;this.updatePause();this.go(index,true);}
      }, {signal});
      this.schedule();
    }
    go(index, manual=false) {
      if (!this.slides.length) return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});
      this.choices.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.index)));
      const announcement=this.querySelector('[data-announcement]');
      if(manual && announcement) announcement.textContent=this.slides[this.index].getAttribute('aria-label');
      this.schedule();
    }
    updatePause(){if(this.pauseButton){this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);}}
    schedule(){clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.go(this.index+1),6500);}
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
